import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';

import {Lesson} from '@edume/magnificent';

import EduMePropTypes from '../../../../../proptypes';

import sharedStyles from '../sharedStyles.module.scss';
import styles from './styles.module.scss';

const {OrderingAnswer, QuestionCountHeader} = Lesson;

const OrderingTaskPreview = ({
  answers,
  phoneHeight,
  intl,
  button,
  questionNumberText,
  numberOfQuestions = 1,
  isPreview = false,
}) => {
  const promptHeight = 72;
  const padding = 30 + 12; // 30px at top, 12px between prompt & answers
  const answerPadding = 16;
  const answerHeight =
    (phoneHeight - promptHeight - padding) / 5 - answerPadding;
  const defaultAnswer = (idx) =>
    intl.formatMessage(
      {id: 'Authoring.editOrderingTask.answerPlaceholder'},
      {n: idx + 1}
    );

  return (
    <>
      <div
        styleName={`activity-preview ordering-activity-preview ${
          isPreview ? 'preview-mode' : ''
        }`}
      >
        <div styleName='ordering-activity-container'>
          <QuestionCountHeader
            questionNumberText={questionNumberText}
            numberOfQuestions={numberOfQuestions}
          />
          {answers.map((answer, index) => (
            <div
              style={{
                height: answerHeight,
                marginBottom: isPreview ? '3px' : '16px',
              }}
              key={index}
            >
              <div styleName='answerWrapper'>
                <OrderingAnswer
                  isPreview={isPreview}
                  key={index}
                  text={answer || defaultAnswer(index)}
                  isReviewing={false}
                  isCorrect={false}
                  isDragging={false}
                  disabled={false}
                  dataAutomation={`quiz-answer${isPreview ? '-thumbnail' : ''}`}
                  accessibilityLabels={{
                    icon: {
                      correct: intl.formatMessage({id: 'Shared.correct'}),
                      incorrect: intl.formatMessage({id: 'Shared.incorrect'}),
                    },
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        {button && !isPreview && (
          <button
            styleName='progress-button'
            data-automation='preview-nav-button'
          >
            <span> {button.text} </span>
            <img src='/resources/img/24_next_dark.svg' />
          </button>
        )}
      </div>
    </>
  );
};

OrderingTaskPreview.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  questionNumberText: PropTypes.string.isRequired,
  numberOfQuestions: PropTypes.number,
  phoneHeight: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  button: EduMePropTypes.buttonParams,
  isPreview: PropTypes.bool,
};

export default injectIntl(
  CSSModules(
    OrderingTaskPreview,
    {...styles, ...sharedStyles},
    {allowMultiple: true}
  )
);
